import React, {ChangeEventHandler, useEffect, useState} from "react";
import {Box, Button, Grid, Stack, Typography} from "@mui/material";
// @ts-ignore
import logo from "../assets/img/ep_slide_logo.png";
import {RoutesList} from "../Modules/RoutesList";
import {useLocation, useNavigate} from "react-router-dom";
import CircularProgress from '@mui/material/CircularProgress';
import RmpServices from "../services"
import {setAxiosToken} from "../http-common";
import {useSelector,useDispatch} from "react-redux";
import routes from "../Modules/RoutesConfig";
import {RootState} from "../app/store";
import {setInitialDevices,setInitialCategories} from '../app/features/userSlice'
import {initializeUser, initializeToken, initializeRole} from '../app/features/Auth'


export interface Ilogin{
    email : string,
    password : string,
}

type LocationState = {
    from: {
        path: string;
    }
}

export const Login = () =>{
    const dispatch = useDispatch()

    const navigate = useNavigate()
    const location = useLocation();

    const [user,setUser] = useState<Ilogin>({
        email : "",
        password : ""
    })

    const [loader,setLoader] = useState<boolean>(false)

    const [err,setError] = useState('')


    const handleLogin = () => {
        setLoader(true)
        setError("")
        RmpServices.login(user)
            .then(response=>{
            if(!response.data.success) {
                setError(response.data.message)
                setLoader(false)
            }

            else{
                setAxiosToken(response.data.token)
                let role = 'supreme-admin'

                localStorage.setItem("user_role",role)
                localStorage.setItem("supreme-token",response.data.token)
                localStorage.setItem("token",response.data.token)
                localStorage.setItem("user",JSON.stringify(response.data.user))



                dispatch(initializeToken(response.data.token))
                dispatch(initializeRole(role))
                dispatch(initializeUser(response.data.user))

                if(role==='user') {
                    // @ts-ignore
                    const from = location.state?.from || RoutesList.Dashboard.Path;
                    navigate(from, { replace: true })
                }
                else if(role === 'admin') {
                    // @ts-ignore
                    const from = location.state?.from || RoutesList.UsersList.path;
                    navigate(from, { replace: true })
                }
                else if(role === 'super-admin') {
                    // @ts-ignore
                    const from = location.state?.from || RoutesList.UsersList.path;
                    navigate(from, { replace: true })
                }
                else if(role === 'supreme-admin') {
                    // @ts-ignore
                    const from = location.state?.from || RoutesList.AllClients.path;
                    navigate(from, { replace: true })
                }
            }

        })
            .catch(error=>{
                if(error.response.data.msg)
                    setError(error.response.data.msg)
                else if(error.response.data.message)
                setError(error.response.data.message)
                setLoader(false)
            })
    }


    const handleInputChange = (e : React.ChangeEvent<HTMLInputElement>) =>{
        setUser(prevState => {
            return { ...prevState, [e.target.name] : e.target.value }
        })
    }
    return(
        <Box
            className = "login-page"
        >

            <Grid container width={"100%"} height={"100%"} justifyContent={"center"} alignItems={"center"}>
                    <Grid
                        container
                        item
                        md={6}
                        sm={5}
                        lg={3}
                        xs={15}
                        className={"login-card"}
                        padding={5}
                        direction={"column"}
                        spacing={3}
                        height={700}
                    >
                            <Grid display={"flex"} justifyContent={"center"} width={"100%"} >
                                <div className = "logo-portrait-login">
                                    <img src={logo}/>
                                </div>
                            </Grid>
                        <Grid item container display={"flex"} width={"100%"} direction={"column"}>
                            <Typography fontSize={32} color={"#089BAB"} fontWeight={700}>
                                Welcome
                            </Typography>
                            <Typography color={err.length>0 ? "red" : "#8F95B2"} fontSize={16} fontWeight={700}>
                                { err.length>0 ?
                                    err :
                                    localStorage.getItem("signUpMessage") ?localStorage.getItem("signUpMessage")
                                        :
                                    "Enter your email and password to Log in" }
                            </Typography>
                        </Grid>

                        <Grid item width={"100%"}>
                            <Stack width={"100%"} direction={"column"} spacing={2}>
                                <Typography fontSize={14}>
                                    Email
                                </Typography>
                                <input placeholder={"Enter your email address"} className={"login-input"} name="email" onChange={handleInputChange} />
                                <Typography fontSize={14}>
                                    Password
                                </Typography>
                                <input className={"login-input"} placeholder={"Enter your password"} name="password" type={"password"} onChange={handleInputChange} />
                            </Stack>
                        </Grid>

                        <Grid item width={"100%"} marginTop={5}>
                            <Button
                                onClick={handleLogin}
                                variant="contained"
                                sx={{
                                    width:"100%",
                                    borderRadius:"16px",
                                    background:"#089BAB",
                                    textTransform:"none",
                                    color:"#F9FAFC",
                                    fontWeight:700,
                                    boxShadow:"none",
                                    padding:1,
                                    fontSize : "16px"
                                }}>Login
                            <CircularProgress sx={{position:"relative",left:"40px",color:"#FFFFFF",display:loader?" ":"none"}} size={25} thickness={6}/>
                            </Button>
                        </Grid>
                        <Grid item display={"flex"} justifyContent={"center"}
                        >
                            <Typography>
                                Don't have any account yet?
                            </Typography>
                            <Typography
                                onClick={()=>navigate(RoutesList.SignUp.path)}
                                color={"#089BAB"}
                            style={{marginLeft:"10px",cursor:"pointer"}}
                            >
                                SignUp
                            </Typography>
                        </Grid>
                    </Grid>
            </Grid>

        </Box>
    )
}